import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useStudyQuery } from "../queries/useStudies"
import { useWelcomeStore } from "../stores/welcomeStore"

const Welcome = () => {
  const navigate = useNavigate()
  const { id } = useParams()

  const { data: study, isLoading } = useStudyQuery(id)

  const { setStudyId, setStudy } = useWelcomeStore()

  const [noticeAccepted, setNoticeAccepted] = useState(false)
  const [openedNotice, setOpenedNotice] = useState(false)

  useEffect(() => {
    if (isLoading) setStudy(null)
    if (study && !isLoading) {
      const studyId = study.id
      setStudyId(studyId.toString())
      setStudy(study)
    }
  }, [setStudyId, setStudy, study, isLoading])

  useEffect(() => {
    if (study)
      document.title = `Demandez votre rendez-vous avec le docteur ${study?.practitioner.name} ${study?.practitioner.surname}`
  }, [study])

  return isLoading ? (
    <div />
  ) : !study ? (
    <div className="flex flex-col items-center justify-center bg-cortexx-50 w-full h-screen">
      <div className="font-semibold lg:text-2xl text-cortexx-900 text-center px-4 text-xl">
        <h1>
          Bienvenue sur la page de demande d'optimisation des délais de
          consultation.
        </h1>
      </div>
      <div className="flex flex-col text-cortexx-900 text-center my-2 gap-1">
        <h1>
          Utilisez le lien communiqué par votre chirurgien pour créer votre
          compte.
        </h1>
        <h1>
          Si vous avez déjà un compte, vous pouvez vous connecter via le bouton
          ci-dessous.
        </h1>
      </div>
      <div className="flex justify-end items-end my-4">
        <button
          className="bg-cortexx-550 hover:opacity-60 rounded-3xl py-2 px-8 text-cortexx-50 font-semibold"
          onClick={() => navigate("/login")}
        >
          <p>Connexion</p>
        </button>
      </div>
    </div>
  ) : (
    <div className="flex items-center justify-center bg-cortexx-50 w-full h-screen">
      <div className="flex items-center flex-col justify-center my-4">
        <div className="flex items-center flex-col justify-center my-4">
          <div className="bg-cortexx-50 mb-8">
            <img
              src={study && study?.administrative_information.logo_url}
              style={{ height: "80px" }}
              alt="Logo centre"
              loading="lazy"
            />
          </div>
          <div className="flex flex-col font-semibold lg:text-2xl text-cortexx-900 text-center px-4 text-xl gap-1">
            <h1>
              {study?.kind === "filter_phase_1"
                ? "Bienvenue sur la page de préparation de votre consultation avec le "
                : "Bienvenue sur la page de demande d'optimisation du délai de consultation avec le "}
            </h1>
            <h1>
              Dr. {study?.practitioner.name} {study?.practitioner.surname}
            </h1>
            <div className="text-base font-normal mt-2">
              Cet outil est en cours d'évaluation par une étude scientifique.
              Vous n'êtes pas obligés d'y participer.
            </div>
            <div className="text-base font-normal">
              En cas d'opposition, il vous faudra faire une demande via le
              système de prise de rendez-vous classique.
            </div>
            <div className="text-base font-normal mt-1">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="text-base font-bold text-cortexx-600"
                onClick={() => setOpenedNotice(true)}
                href="https://storage.googleapis.com/filter-apps/filter-assets/Lettre%20d'information%20FILTER3.pdf"
              >
                Lire la fiche d'informations
              </a>
            </div>
            <div className="flex flex-row gap-2 w-full justify-center mt-3">
              <input
                type="checkbox"
                name={"notice"}
                id={"notice"}
                value={"notice"}
                onChange={() => setNoticeAccepted(!noticeAccepted)}
                checked={noticeAccepted}
              />
              <button
                className="text-sm font-normal"
                onClick={() => setNoticeAccepted(!noticeAccepted)}
              >
                Je ne m'oppose pas
              </button>
            </div>
          </div>
        </div>
        <div className="flex items-center flex-row justify-center my-4">
          <div className="flex justify-end items-end mx-4">
            <button
              className={
                !noticeAccepted
                  ? "bg-cortexx-100 rounded-3xl py-2 px-8 text-cortexx-550 font-semibold opacity-70"
                  : "bg-cortexx-500 hover:opacity-60 rounded-3xl py-2 px-8 text-cortexx-50 font-semibold"
              }
              disabled={!noticeAccepted}
              onClick={() => navigate("/signup")}
            >
              <p>Inscription</p>
            </button>
          </div>
          <div className="flex justify-end items-end mx-4">
            <button
              className="bg-cortexx-550 hover:opacity-60 rounded-3xl py-2 px-8 text-cortexx-50 font-semibold"
              onClick={() => navigate("/login")}
            >
              <p>Connexion</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Welcome
